import type { ChatMessageJump } from "@ext/agent/components/types/chat";

const FOUND_CLASS = "is-found-article-element";

const isRendered = (element: HTMLElement) => element.getClientRects().length > 0;

export const findJumpTarget = (root: HTMLElement, jump: ChatMessageJump): HTMLElement | null => {
	const message = root.querySelector<HTMLElement>(`[data-message-ts="${jump.ts}"]`);
	if (message && isRendered(message)) return message;
	return root.querySelector<HTMLElement>(`[data-turn-ts="${jump.turnTs}"]`);
};

export const getCenteredScrollTop = (root: HTMLElement, target: HTMLElement): number => {
	const rootRect = root.getBoundingClientRect();
	const targetRect = target.getBoundingClientRect();
	const targetTop = targetRect.top - rootRect.top + root.scrollTop;
	if (targetRect.height >= root.clientHeight) return targetTop;
	return targetTop - (root.clientHeight - targetRect.height) / 2;
};

export const flashJumpTarget = (target: HTMLElement) => {
	target.classList.add(FOUND_CLASS);
	target.addEventListener("animationend", () => target.classList.remove(FOUND_CLASS), { once: true });
};
